
import Tools from '@/tools/tools'

export default {
  async imprimir(compra, http, store) {
    const janela = window.open('', '_blank')
    if (!janela) {
      Tools.exibirMensagem(store, 'Atenção', 'warning', 'Navegador bloqueou a abertura do relatório.')
      return
    }

    try {
      janela.document.write('<html><head><title>Gerando Espelho...</title><style>body{font-family:sans-serif;display:flex;justify-content:center;align-items:center;height:100vh;}</style></head><body><h3>Gerando espelho da conferência...</h3></body></html>')
      
      const response = await http.get(`/api/protected/terminal/compra/getDadosTerminalByPedidoId/${compra.ID}`)
      const dados = response.data
      
      const empresa = { NOME: 'CEC - CENTRAL DE ESTOQUE', CNPJ: '00.000.000/0001-00' }
      
      const html = this.montarHtml(compra, dados, empresa)
      janela.document.open()
      janela.document.write(html)
      janela.document.close()
    } catch (err) {
      console.error(err)
      janela.close()
      Tools.exibirMensagem(store, 'Erro', 'danger', 'Erro ao gerar espelho da conferência')
    }
  },

  montarHtml(compra, dados, empresa) {
    const dataHora = new Date().toLocaleString('pt-BR')
    const conferente = dados.pedido[0]?.USUARIO_CONFERENCIA || '—'
    const placa = dados.pedido[0]?.PLACA || '—'
    
    let linhasEtiquetas = ''
    dados.etiquetas.forEach(e => {
      const situacao = e.SITUACAO === '8' ? 'COLETADO' : (e.SITUACAO === '2' ? 'FINALIZADO' : 'PENDENTE')
      linhasEtiquetas += `
        <tr>
          <td>${e.SEQUENCIA_EMBARQUE || '—'}</td>
          <td>${e.ID}</td>
          <td>${e.DESCRICAO}</td>
          <td style="text-align:right;">${Number(e.PESO).toFixed(3)} kg</td>
          <td style="text-align:center;"><span class="badge-${e.SITUACAO}">${situacao}</span></td>
        </tr>
      `
    })

    let linhasResumo = ''
    let totalPeso = 0
    let totalLabels = 0
    
    // Agrupar itens esperados para busca rápida
    const mapaEsperado = {}
    dados.itens.forEach(i => {
      mapaEsperado[i.PRODUTO_ID] = i
    })

    dados.resumo.forEach(r => {
      totalPeso += Number(r.QUANT)
      totalLabels += Number(r.PECAS)
      
      const exp = mapaEsperado[r.PRODUTO_ID] || { QT_PECAS: 0, NR_PESO_BRUTO: 0 }
      const diffPecas = Number(r.PECAS) - Number(exp.QT_PECAS)
      const diffPeso = Number(r.QUANT) - Number(exp.NR_PESO_BRUTO)
      
      const classDiffPecas = diffPecas < 0 ? 'text-danger' : (diffPecas > 0 ? 'text-success' : '')
      const classDiffPeso = diffPeso < 0 ? 'text-danger' : (diffPeso > 0 ? 'text-success' : '')

      linhasResumo += `
        <tr>
          <td>${r.PRODUTO_ID}</td>
          <td>${r.DESCRICAO}</td>
          <td style="text-align:center;">${Number(exp.QT_PECAS)}</td>
          <td style="text-align:center;">${r.PECAS}</td>
          <td style="text-align:center; font-weight:bold;" class="${classDiffPecas}">${diffPecas > 0 ? '+' : ''}${diffPecas}</td>
          <td style="text-align:right;">${Number(exp.NR_PESO_BRUTO).toFixed(3)} kg</td>
          <td style="text-align:right;">${Number(r.QUANT).toFixed(3)} kg</td>
          <td style="text-align:right; font-weight:bold;" class="${classDiffPeso}">${diffPeso > 0 ? '+' : ''}${diffPeso.toFixed(3)} kg</td>
        </tr>
      `
    })

    return `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Espelho de Conferência - #${compra.ID}</title>
        <style>
          body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; margin: 0; padding: 40px; color: #333; font-size: 11px; }
          .header { display: flex; justify-content: space-between; border-bottom: 2px solid #333; padding-bottom: 10px; margin-bottom: 20px; }
          .header h1 { margin: 0; font-size: 18px; color: #1a365d; }
          .info-grid { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 15px; margin-bottom: 20px; background: #f7fafc; padding: 12px; border-radius: 8px; border: 1px solid #e2e8f0; }
          .info-item label { display: block; font-weight: bold; color: #718096; text-transform: uppercase; font-size: 9px; margin-bottom: 2px; }
          .info-item span { font-size: 13px; font-weight: 600; }
          .kpi-row { display: flex; gap: 15px; margin-bottom: 20px; }
          .kpi-card { flex: 1; background: #fff; border: 1px solid #e2e8f0; padding: 12px; border-radius: 8px; text-align: center; }
          .kpi-card small { color: #718096; font-size: 9px; text-transform: uppercase; font-weight: bold; }
          .kpi-card div { font-size: 18px; font-weight: 800; color: #2d3748; margin-top: 4px; }
          h2 { font-size: 12px; text-transform: uppercase; border-left: 4px solid #4a5568; padding-left: 10px; margin: 25px 0 12px 0; color: #2d3748; }
          table { width: 100%; border-collapse: collapse; margin-bottom: 20px; table-layout: fixed; }
          th { background: #edf2f7; text-align: left; padding: 8px; border-bottom: 2px solid #cbd5e0; text-transform: uppercase; font-size: 9px; color: #4a5568; }
          td { padding: 8px; border-bottom: 1px solid #e2e8f0; word-wrap: break-word; }
          .text-danger { color: #e53e3e; }
          .text-success { color: #38a169; }
          .badge-8 { background: #c6f6d5; color: #22543d; padding: 2px 6px; border-radius: 4px; font-size: 8px; font-weight: bold; }
          .badge-2 { background: #bee3f8; color: #2a4365; padding: 2px 6px; border-radius: 4px; font-size: 8px; font-weight: bold; }
          .badge-7 { background: #fed7d7; color: #822727; padding: 2px 6px; border-radius: 4px; font-size: 8px; font-weight: bold; }
          .footer { margin-top: 40px; text-align: center; font-size: 9px; color: #a0aec0; border-top: 1px solid #e2e8f0; padding-top: 10px; }
          @media print { body { padding: 10px; } .no-print { display: none; } }
        </style>
      </head>
      <body>
        <div class="header">
          <div>
            <h1>ESPELHO DE CONFERÊNCIA FÍSICA</h1>
            <div style="font-weight:600;">${empresa.NOME}</div>
          </div>
          <div style="text-align:right;">
            <div style="font-weight:bold;">Compra #${compra.ID}</div>
            <div>Gerado em: ${dataHora}</div>
          </div>
        </div>

        <div class="info-grid">
          <div class="info-item"><label>Fornecedor</label><span>${compra.NOME_FORNECEDOR || '—'}</span></div>
          <div class="info-item"><label>Nota Fiscal</label><span>${compra.NOTA_FISCAL || '—'}</span></div>
          <div class="info-item"><label>Data Pedido</label><span>${compra.DT_PEDIDO ? new Date(compra.DT_PEDIDO).toLocaleDateString('pt-BR') : '—'}</span></div>
          <div class="info-item"><label>Conferente</label><span>${conferente}</span></div>
          <div class="info-item"><label>Placa Veículo</label><span>${placa}</span></div>
          <div class="info-item"><label>Status Recepção</label><span>${this.getTraducaoStatus(compra.OP_RECEPCAO)}</span></div>
        </div>

        <div class="kpi-row">
          <div class="kpi-card"><small>Total Etiquetas</small><div>${compra.TOTAL_ETIQUETAS || 0}</div></div>
          <div class="kpi-card"><small>Qtd Conferida</small><div>${totalLabels}</div></div>
          <div class="kpi-card"><small>Peso Total Conferido</small><div>${totalPeso.toFixed(3)} kg</div></div>
        </div>

        <h2>Resumo por Produto</h2>
        <table>
          <thead>
            <tr>
              <th style="width:50px;">Cód.</th>
              <th>Produto</th>
              <th style="width:60px; text-align:center;">Exp. (V)</th>
              <th style="width:60px; text-align:center;">Conf. (V)</th>
              <th style="width:60px; text-align:center;">Dif. (V)</th>
              <th style="width:90px; text-align:right;">Peso Exp.</th>
              <th style="width:90px; text-align:right;">Peso Conf.</th>
              <th style="width:90px; text-align:right;">Dif. Peso</th>
            </tr>
          </thead>
          <tbody>${linhasResumo}</tbody>
        </table>

        <div style="page-break-before: always;"></div>
        <h2>Sequência Detalhada de Leitura</h2>
        <table>
          <thead>
            <tr>
              <th style="width:40px;">Seq.</th>
              <th style="width:80px;">ID Etiq.</th>
              <th>Produto</th>
              <th style="width:100px; text-align:right;">Peso Líquido</th>
              <th style="width:80px; text-align:center;">Situação</th>
            </tr>
          </thead>
          <tbody>${linhasEtiquetas}</tbody>
        </table>

        <div class="footer">
          SISTEMA CECWEB - GESTÃO COMERCIAL E LOGÍSTICA
        </div>

        <script>window.onload = function() { window.print(); }<\/script>
      </body>
      </html>
    `
  },

  getTraducaoStatus(val) {
    switch (val) {
      case '0': return 'NÃO SOLICITADO'
      case '1': return 'ABERTA'
      case '2': return 'EM CONFERÊNCIA'
      case '3': return 'CONFERIDO'
      default: return '—'
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/reports/CompraConferenciaReport.js